
import { apiRequest, SUPABASE_URL } from './apiUtils';
import { CustomerType } from '@/models/CustomerType';

export const customerTypeApi = {
  /**
   * List all customer types
   */
  async list(): Promise<CustomerType[]> {
    try {
      const url = `${SUPABASE_URL}/customer-types`;
      return await apiRequest<CustomerType[]>(url);
    } catch (error) {
      console.error('Error fetching customer types:', error);
      return [];
    }
  },

  /**
   * Get a customer type by ID
   */
  async getById(id: number): Promise<CustomerType | null> {
    try {
      const url = `${SUPABASE_URL}/customer-types/${id}`;
      return await apiRequest<CustomerType>(url);
    } catch (error) {
      console.error(`Error fetching customer type ${id}:`, error);
      return null;
    }
  }
};

